<template>
	<article ref="scrollBox" class="home bus_list_wrap CompareFlightIndex" style="height:100%;">
		<section class="pages_content">
			<swiper :swiperImgArray="advertList" :swiperWrapClass="swiperClass" style="position:relative;z-index:1;"></swiper>

			<div class="queryConditions" style="margin-top:-30px;padding: 1rem 0.8rem;">
				<div class>
					<div class="inputDiv fontSize4 fontWeightChang">
						<i class="iconfont_new icon-dingwei3 inputIcon"></i>
						<span class="inputTitle">候&nbsp;&nbsp;机&nbsp;&nbsp;楼：</span>
						<RadioGroup v-model="GetOnValue" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
							<Radio :label="data.PlaceName" v-for="data in getOnList" :key="data.id" :disabled="data.PlaceName == '古镇候机楼'">
								<span>{{ data.PlaceName }}</span>
							</Radio>
						</RadioGroup>
					</div>
					<div style="margin-top:0.5rem;" class="inputDiv fontSize4 fontWeightChang" @click="showSetDatePicker">
						<i class="iconfont_new icon-rili inputIcon"></i>
						<span class="inputTitle">出发日期：</span>
						<div style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
							{{ SetDate }}
							<span v-if="SetDate == today" class="colorprimary">（今天）</span>
							<span v-if="SetDate == tomorrow" class="colorprimary">（明天）</span>
						</div>
					</div>
					<div class="inputDiv fontSize4 fontWeightChang" style="margin-top:0.5rem;">
						<i class="iconfont_new icon-dingwei3 inputIcon"></i>
						<span class="inputTitle">机&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;场：</span>
						<RadioGroup v-model="GetOffValue" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;" @on-change="changeGetOff">
							<Radio :label="data.PlaceName" v-for="data in getOffList" :key="data.id" :disabled="data.PlaceName == '广州南站(即将开通)'">
								<span>{{ data.PlaceName }}</span>
							</Radio>
						</RadioGroup>
					</div>
					<div class="inputDiv fontSize4 fontWeightChang" style="margin-top:0.5rem;">
						<i class="iconfont_new icon-fenzu2 inputIcon"></i>
						<span class="inputTitle">行程类型：</span>
						<RadioGroup v-model="GetTypeValue" style="width:calc(100% - 2.8rem);margin-left: 2.8rem;">
							<Radio :label="1"><span>去程</span></Radio>
							<Radio :label="2" :disabled="disabledTpye"><span>返程</span></Radio>
							<Radio :label="3" :disabled="disabledTpye"><span>往返套票</span></Radio>
						</RadioGroup>
					</div>

					<div class="flexContainer" style="margin-top:0.8rem;">
						<div class="flexItem1"><div class="queryConditionsButton textalignM" @click="getBusList">查询班次</div></div>
					</div>
				</div>
			</div>
		</section>
	</article>
</template>

<script>
import scopeApi from '../request/scopeApi';
import frequencyApi from '../request/frequencyApi';
import baseTool from '../utils/baseFunction';
import { mapState } from 'vuex';
import Swiper from './child-components/Swiper';
export default {
	name: 'BusQueryIndex',
	data() {
		return {
			advertList: [],
			swiperClass: 'big_banner_wrap',
			today: baseTool.formatterDate(new Date()), //今天
			tomorrow: baseTool.formatterDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)), //明天

			GetOnValue: '懿峯亚朵酒店候机楼',
			GetOffValue: '广州机场',
			GetTypeValue: 1,
			disabledTpye: false,

			getOnList: [],
			getOffList: [],

			tipsType: 'buyTicket'
		};
	},
	components: {
		swiper: Swiper
	},
	mounted() {
		this.getAdvertList();
		this.getGetOnList();
		this.getGetOffList();
	},
	activated() {
		this.$store.commit('ticket/setBaseTicketCondition', {
			GetOn: '懿峯亚朵酒店候机楼',
			GetOff: '广州机场',
			GetType: 1
		});
		this.GetOnValue = '懿峯亚朵酒店候机楼';
		this.GetOffValue = '广州机场';
		this.GetTypeValue = 1;
	},
	methods: {
		//获取轮播图列表：
		getAdvertList() {
			let that = this;
			this.advertList = [];
			scopeApi.getAdvertInfoList(2).then(sucRes => {
				if (sucRes.success) {
					for (let i = 0; i < sucRes.data.length; i++) {
						that.advertList.push(sucRes.data[i].GoodsLogoUrl);
					}
				}
			});
			this.advertList.push('http://www.callmefix.net/api/Event/getImage?type=3&name=38');
		},
		//目的地改变:
		changeGetOff(e) {
			if (e == '广州机场') {
				this.disabledTpye = false;
			} else {
				this.disabledTpye = true;
				this.GetTypeValue = 1;
			}
		},
		//点击查询：
		getBusList() {
			this.$store.commit('ticket/setBaseTicketCondition', {
				GetOn: this.GetOnValue,
				GetOff: this.GetOffValue,
				GetType: this.GetTypeValue
			});

			//选择了返程，则跳去“确认订单”页
			if (this.GetTypeValue == 2) {
				this.$router.push({
					name: 'MakeTicketOrder',
					params: {
						mode: 0
					}
				});
			} else {
				this.$router.push({
					name: 'ChooseFrequencyList',
					params: {
						mode: 0
					}
				});
			}
		},
		//获取出发地列表：
		getGetOnList() {
			let that = this;
			frequencyApi.getGetOnList(1, 1).then(sucRes => {
				that.getOnList = sucRes.data;
				if (that.getOnList.length > 0) {
					// that.getOn = that.getOnList[0].PlaceName;
					that.$store.commit('ticket/setBaseTicketCondition', {
						GetOn: that.getOnList[0].PlaceName
					});
				}
			});
		},
		//获取目的地列表：
		getGetOffList() {
			let that = this;
			frequencyApi.getGetOffList(1, 1).then(sucRes => {
				that.getOffList = sucRes.data;
				if (that.getOffList.length > 0) {
					// that.getOff = that.getOffList[0].PlaceName;
					that.$store.commit('ticket/setBaseTicketCondition', {
						GetOff: that.getOffList[0].PlaceName
					});
				}
			});
		},

		getDate(type) {
			const date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let day = date.getDate();

			if (type === 'start') {
				year = year - 60;
			} else if (type === 'end') {
				year = year + 2;
			}
			month = month > 9 ? month : '0' + month;
			day = day > 9 ? day : '0' + day;
			return `${year}-${month}-${day}`;
		},
		//选择出发日期：
		showSetDatePicker() {
			let that = this;
			this.$weui.datePicker({
				start: new Date(), // 从今天开始
				end: baseTool.addDate(new Date(), 60),
				onConfirm: function(result) {
					let tmpDate =
						result[0].value +
						'-' +
						(result[1].value < 10 ? '0' + result[1].value : result[1].value) +
						'-' +
						(result[2].value < 10 ? '0' + result[2].value : result[2].value);

					that.$store.commit('ticket/setBaseTicketCondition', {
						SetDate: tmpDate
					});
				}
			});
		}
	},
	computed: mapState({
		startDate() {
			return this.getDate('start');
		},
		endDate() {
			return this.getDate('end');
		},
		SetDate: state => state.ticket.SetDate,
		GetOn: state => state.ticket.GetOn,
		GetOff: state => state.ticket.GetOff,
		GetType: state => state.ticket.GetType
	})
};
</script>

<style scoped lang="less">
@import '../style/home.less';
span.ivu-radio + * {
	font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/BusQueryIndex.vue